//1.导入Vuex插件
import Vue from 'vue';
import Vuex from 'vuex';

import state from './state'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex);
//2.创建存储容器
export default new Vuex.Store({
	state,
	mutations,
	actions
})



// WEBPACK FOOTER //
// ./docs/store/index.js